import {
  applyRuntimeConfig
} from "./chunk-33FKEMJY.js";

// src/frontend.ts
function setRuntimeConfig(config) {
  assertBrowserContext();
  applyRuntimeConfig(config);
}
function clearRuntimeConfig() {
  assertBrowserContext();
  applyRuntimeConfig(null);
}
function assertBrowserContext() {
  if (typeof window === "undefined") {
    throw new RuntimeContextError(
      "setRuntimeConfig/clearRuntimeConfig must only be called from a browser context."
    );
  }
}
var RuntimeContextError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "RuntimeContextError";
  }
};
export {
  clearRuntimeConfig,
  setRuntimeConfig
};
//# sourceMappingURL=frontend.js.map